import React from 'react';
import moment from 'moment';

import EmptyData from '../../../components/UI/EmptyData';
import { withoutProfilePicture } from '../../../utils/handler';
import CelebrationSnapSlider from './CelebrationSnapSlider';

const LatestHiring = ({ latestHiringList, embedded }) => {
  const embeddedSection = (
    <div
      className={`${embedded ? 'px-0' : 'card-body px-0'} dashboard-celebrations-scroll dashboard-celebrations-scroll--compact`}
    >
      <div className="px-2 px-sm-3">
        <CelebrationSnapSlider variant="hiring" items={(latestHiringList || []).slice(0, 6)} />
      </div>
    </div>
  );

  const listSection = (
    <div
      className={`${embedded ? 'px-0' : 'card-body'} dashboard-celebrations-scroll`}
      style={{ height: '18rem', overflowY: 'auto' }}
    >
      <div className="flex-grow-1">
        {latestHiringList?.length > 0 ? (
          latestHiringList?.map((work, i) => (
            <div key={i} className="py-2 d-flex align-items-center border-bottom flex-wrap">
              <div className="d-flex align-items-center flex-fill">
                <img
                  className="avatar lg rounded-circle img-thumbnail"
                  src={
                    work?.profilePicture ? work.profilePicture : withoutProfilePicture(work?.name)
                  }
                  alt="profile"
                />
                <div className="d-flex flex-column ps-3">
                  <h6 className="fw-bold mb-0 small-14">{work?.name || ''}</h6>
                  <span
                    className="text-muted"
                    style={{
                      maxWidth: '130px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {work?.designation || ''}
                  </span>
                </div>
              </div>
              <div className="time-block text-truncate w-30">
                <i className="icofont-hat"></i>{' '}
                {work?.dateOfJoining ? moment(work?.dateOfJoining).format('DD-MMM-YYYY') : '-'}
              </div>
            </div>
          ))
        ) : (
          <div>
            <EmptyData />
          </div>
        )}
      </div>
    </div>
  );

  if (embedded) {
    return embeddedSection;
  }

  return (
    <div className="card">
      <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
        <h6 className="mb-0 fw-bold ">Recent Hiring</h6>
      </div>
      {latestHiringList?.length > 0 ? embeddedSection : listSection}
    </div>
  );
};

export default LatestHiring;
